import styled from "styled-components";

export const StyledFormTextArea = styled.textarea`
  background: var(--CLOUD, #fcfdfe);
  border-radius: 4px;
  border: 1px solid
    ${({ $variant }) => ($variant === "light" ? "#ECF1F4" : "var(--LIGHT-ASH, #b9b9c6)")};
  color: var(--ASH, #676879);
  font-size: 14px;
  font-weight: 400;
  height: ${props => (props.$height ? props.$height : "32px")};
  min-height: 32px;
  line-height: 22px;
  margin-bottom: 4px;
  padding: 4px 4px 4px 12px;
  resize: ${props => (props.$resize ? props.$resize : "none")};
  width: 100%;
  -webkit-appearance: none;

  &:focus,
  &:focus-visible {
    border: 1px solid var(--DARK-BLUE, #1249bf);
    outline: none;
  }
`;
